import { Directive } from '@angular/core';
import { NG_VALIDATORS, FormControl, Validator, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[destinatario-validator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: DestinatarioValidatorDirective, multi: true }]
})
export class DestinatarioValidatorDirective implements Validator {

  validate(c: FormControl): ValidationErrors {
    console.log('destinatario-validator', c.value);
    const isValid = c.value && c.value.value;
    const message = {
      'audience': {
        'message': 'Specificare un destinatario'
      }
    };
    return isValid ? null : message;
  }
}



// WEBPACK FOOTER //
// ./src/app/helpers/validators/destinatario-validator.directive.ts